export default __webpack_public_path__ + "static/media/escalator-down.inline.4b5f72b1.svg";